export var doNotForwardTransientProp = function doNotForwardTransientProp(props) {
  return function (prop, defaultValidatorFn) {
    return props.indexOf(prop) === -1 && defaultValidatorFn(prop);
  };
};